import { CounterpartyTypeEnum } from '@talos/kyoko';

/** Default Exchange counterparty names eligible for LP Settlement when org config is unset. */
export const DEFAULT_LP_SETTLEMENT_ELIGIBLE_EXCHANGE_COUNTERPARTY_NAMES = [
  'coinbase_prime',
  'bitstamp',
  'bitvavo',
  'edx',
] as const;

/**
 * Exchange counterparties allowed to configure LP Settlement (Counterparties Exchange tab and Addresses Exchange tab).
 * Matches exact counterparty names or `{name}_*` variants (e.g. `coinbase_prime`, `coinbase_prime_us`).
 * When `eligibleExchangeCounterpartyNames` is empty (e.g. org config `ui.LPSettlementEligibleExchangeCounterparties`
 * set to `""`), no Exchange counterparty is eligible.
 */
export function isLpSettlementEligibleExchangeCounterparty(
  counterparty: { Type?: CounterpartyTypeEnum; Name?: string } | undefined,
  eligibleExchangeCounterpartyNames: readonly string[] = DEFAULT_LP_SETTLEMENT_ELIGIBLE_EXCHANGE_COUNTERPARTY_NAMES
): boolean {
  if (!counterparty?.Name || counterparty.Type !== CounterpartyTypeEnum.Exchange) {
    return false;
  }

  const { Name: name } = counterparty;

  return eligibleExchangeCounterpartyNames.some(
    eligibleName => name === eligibleName || name.startsWith(`${eligibleName}_`)
  );
}
